module.exports = __webpack_public_path__ + "static/media/icon_nav_on_store.314b7a33.svg";